import { render, staticRenderFns } from "./Direccion.vue?vue&type=template&id=06d426ac&scoped=true"
import script from "./Direccion.vue?vue&type=script&lang=js"
export * from "./Direccion.vue?vue&type=script&lang=js"
import style0 from "./Direccion.vue?vue&type=style&index=0&id=06d426ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d426ac",
  null
  
)

export default component.exports